module.exports = __webpack_public_path__ + "img/sunspec_alliance.213226b4.png";